import { ContentWrapper } from '@eti/components';
import { css } from '@eti/styles';
import { breakpoints, Inline, Stack } from '@etg/wings';
import { useDirection, useTranslation } from '@eti/providers';
import { useAuth } from '@eti/authentication';
import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';
import { constants } from '@eti/utils';
import { screenReadersOnlyStyles } from '../../../../utils/styleUtils';
import TitledCard from '../../../../common/components/TitledCard';
import { routes } from '../../../../constants/routesAndApisConstants';
import { SHOW_AIRLINE_INFORMATION_QUERY_PARAMETER } from '../../constants/general';
import ClickableCard from '../../../../common/components/ClickableCard';
import AirlineInfoClickableContent from '../common/AirlineInfoClickableContent';
import { useRoutedTabs } from '../../../../widgets/tabs/components/RoutedTabs';
import Topics from './Topics';

const airlineInfoWrapperStyles = css`
  height: 100%;
`;

const alignStretchStyles = css`
  align-items: stretch;
`;

const clickableCardStyles = css`
  background-color: #fff;
  border: none;
  color: inherit;
  flex: 1;
  height: auto;
  padding: 16px;
  text-decoration: none;

  &:focus-visible {
    outline-offset: -0.1875rem;
  }
`;

const contentWrapperStyles = css`
  margin-bottom: 40px;
`;

const flexStyles = css`
  flex: 1;
`;

const inlineStyles = css`
  gap: 0 4px;
`;

const stackStyles = css`
  margin-top: 16px;

  @media (min-width: ${breakpoints._768}) {
    margin-top: 24px;
  }
`;

const OrderDetailsContactUs = () => {
  const { t } = useTranslation();
  const { isRTL } = useDirection();
  const { user } = useAuth();
  const { tabHeading1Ref } = useRoutedTabs();

  return (
    <ContentWrapper className={contentWrapperStyles} dataTestId="order-details-contact-us-v3">
      <Stack className={stackStyles} spacing={24}>
        <h1 className={screenReadersOnlyStyles} ref={tabHeading1Ref} tabIndex={-1}>
          {t('OrderDetails.Tab.ContactUs.Description')}
        </h1>
        <Stack spacing={{ [breakpoints._0]: 16, [breakpoints._970]: 24 }}>
          <Inline
            className={alignStretchStyles}
            collapseBelow={breakpoints._970}
            spacing={{ [breakpoints._970]: 24, [breakpoints._0]: 16 }}
          >
            <TitledCard
              className={flexStyles}
              data-testid="contact-us-booking-details"
              spacing={8}
              title={t('ContactUs.BookingDetailsSection.Title')}
            >
              <Inline className={inlineStyles}>
                <span>{t('ContactUs.BookingDetailsSection.Email')}</span>
                <span
                  className={constants.MOUSE_FLOW_CLASS_NAMES}
                  data-testid="booking-details-email"
                >
                  {user?.email}
                </span>
              </Inline>
              <Inline className={inlineStyles}>
                <span>{t('ContactUs.BookingDetailsSection.OrderNumber')}</span>
                <strong
                  className={constants.MOUSE_FLOW_CLASS_NAMES}
                  data-testid="booking-details-order-number"
                >
                  {user?.sessionOrderNumber}
                </strong>
              </Inline>
            </TitledCard>
            <ClickableCard
              as={Link}
              className={clickableCardStyles}
              data-testid="contact-us-airline-info-link"
              to={`${routes.ORDER_DETAILS}?${SHOW_AIRLINE_INFORMATION_QUERY_PARAMETER}=true`}
            >
              <Inline alignY="center" className={airlineInfoWrapperStyles} noWrap>
                <AirlineInfoClickableContent />
                <CaretRight
                  color="#262626"
                  data-testid="airline-info-caret-icon"
                  mirrored={isRTL}
                  size={24}
                />
              </Inline>
            </ClickableCard>
          </Inline>
          <Topics />
        </Stack>
      </Stack>
    </ContentWrapper>
  );
};

export default OrderDetailsContactUs;
